import { render, staticRenderFns } from "./PerkClaim.vue?vue&type=template&id=e7f0eb58&scoped=true&"
import script from "./PerkClaim.vue?vue&type=script&lang=js&"
export * from "./PerkClaim.vue?vue&type=script&lang=js&"
import style0 from "./PerkClaim.vue?vue&type=style&index=0&id=e7f0eb58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f0eb58",
  null
  
)

export default component.exports